import { useMemo } from 'react';

import { useCaseGetJobRequestsCountByStatus } from 'application/approvals/useCases/useCaseGetJobRequestsCountByStatus';
import { useTranslationPrefix } from 'infrastructure/translations/i18n';
import { useAcceptDeclineViewFilters } from 'targets/web/modules/approvals/hooks/useAcceptDeclineViewFilters';
import { getLabelWithValue, Tabs } from 'targets/web/components';

export const AcceptDeclineTabs = () => {
  const t = useTranslationPrefix('approvals.approvals_view.tabs');

  const { filters, statusTab, setStatusTab } = useAcceptDeclineViewFilters();
  const params = useMemo(
    () => ({
      aircraftId: filters.aircraftId,
      airportIds: filters.airports?.map((airport) => airport.id),
      stationIds: filters.stations?.map((station) => station.id),
      facilityIds: filters.facilities?.map((facility) => facility.id),
      customerId: filters.customerId,
      dateEnd: filters.dateEnd,
      dateStart: filters.dateStart,
      phrase: filters.phrase,
      serviceTypeId: filters.serviceTypeId,
    }),
    [filters],
  );
  const { data } = useCaseGetJobRequestsCountByStatus({ ...params });

  return (
    <Tabs
      onChange={(_, status) => setStatusTab(status)}
      value={statusTab}
      items={[
        {
          label: getLabelWithValue(t('needs_review'), data?.created),
          value: 'created',
        },
        {
          label: getLabelWithValue(t('accepted'), data?.accepted),
          value: 'accepted',
        },
        {
          label: getLabelWithValue(t('declined'), data?.denied),
          value: 'denied',
        },
      ]}
    />
  );
};
